/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-05-26 17:09:52
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-07-22 14:48:18
 * @FilePath: \crm-product\src\views\performanceCalculation\views\result_statement\terminal_performance_target_report\table\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  components: {},
  name: 'PersonalizedIndicatorTable',
  data() {
    return {

    };
  },
  created() {
    this.getConfigList('main-list');
  },

  methods: {
    afterGetList() {
      this.tableData = this.tableData.map((item) => ({
        ...item,
        banquetRate: item.banquetRate ? `${item.banquetRate}%` : item.banquetRate,
        particRate: item.particRate ? `${item.particRate}%` : item.particRate,
        dealerRate: item.dealerRate ? `${item.dealerRate}%` : item.dealerRate,
        visitRate: item.visitRate ? `${item.visitRate}%` : item.visitRate,
      }));
    },
    modalClick({
      val,
      row,
    }) {},
  },
};
